import React from 'react';
import styles from './InStock.module.scss';
import Icon from '../../../BaseModule/Components/Layout/Icon/Icon';
import useTranslation from '../../../../Hooks/useTranslation';

export interface InStockProps {
	inStock: boolean;
}

const InStock: React.FC<InStockProps> = ({ inStock }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.stock}>
			<div className={inStock ? styles.inStock : styles.uponInquiry}>
				<Icon name={'fa-circle-check'} />
			</div>
			<div>
				<div>
					{inStock
						? t('component.drmax.medicamentInStock')
						: t('component.drmax.uponInquiry')}
				</div>
			</div>
		</div>
	);
};

export default InStock;
